import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight, Lock } from 'lucide-react';

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex">
      {/* Left side - Image */}
      <div 
        className="hidden lg:block lg:w-1/2 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/8770485/pexels-photo-8770485.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)'
        }}
      >
        <div className="h-full bg-gradient-to-r from-[#0F203C]/80 to-transparent flex items-center p-16">
          <div className="text-white">
            <h2 className="text-4xl font-bold mb-4">L'eau au cœur de nos territoires</h2>
            <p className="text-xl opacity-90">Mayane Résilience Center</p>
          </div>
        </div>
      </div>

      {/* Right side - Content */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 md:p-16 bg-[#F8FAFC]">
        <div className="max-w-2xl">
          <div className="mb-8">
            <div className="inline-block px-4 py-1 bg-[#8A6D1F]/10 text-[#8A6D1F] rounded-full text-sm font-semibold mb-6">
              ENQUÊTE SOCIOLOGIQUE
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-[#0F203C] mb-6 leading-tight tracking-tight">
              État des lieux des pratiques et des opinions en matière de batardeaux
            </h1>
            <p className="text-lg text-[#475569] leading-relaxed mb-8">
              Cette enquête vise à comprendre les pratiques et opinions des propriétaires et gestionnaires de biens concernant les dispositifs de protection contre les inondations (batardeaux).
            </p>
            <div className="space-y-3 mb-10">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-[#8A6D1F] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-[#475569]">Anonyme et confidentiel</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-[#8A6D1F] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-[#475569]">Durée estimée : 10-15 minutes</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-[#8A6D1F] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-[#475569]">Contribuez à la recherche en sociologie des risques</p>
              </div>
            </div>
          </div>

          <div className="flex gap-3 flex-wrap">
            <Button 
              data-testid="start-survey-button"
              onClick={() => navigate('/survey')}
              size="lg"
              className="bg-[#0F203C] hover:bg-[#0a1526] text-white px-8 py-6 text-lg font-semibold rounded-md transition-all duration-200 group"
            >
              Commencer l'enquête
              <ChevronRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>

            <Button 
              data-testid="back-office-button"
              onClick={() => navigate('/login')}
              size="lg"
              variant="outline"
              className="border-2 border-[#8A6D1F] text-[#0F203C] hover:bg-[#8A6D1F]/10 px-8 py-6 text-lg font-semibold rounded-md transition-all duration-200 group"
            >
              <Lock className="mr-2 w-5 h-5" />
              Back Office
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t border-[#E2E8F0]">
            <p className="text-sm text-[#475569]">
              Une initiative du <span className="font-semibold text-[#0F203C]">Mayane Résilience Center</span> en partenariat avec l'AFPCNT et MRN
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;